<template>
  <div class="tab-content tab-images">
    <el-form ref="form" label-position="top" size="small">
      <el-row :gutter="15">
        <el-col :span="10">
          <el-form-item label="Master Thumbnail">
            <div class="uploader-image">
              <el-upload
                :show-file-list="false" action="" :http-request="uploadImage" :before-upload="beforeImageUpload"
                :data="{ model: 'products', id: product._id, type: 'thumbnail' }"
              >
                <div class="uploader-preview" v-if="images.thumbnail.url">
                  <el-image class="preview-img" :src="images.thumbnail.url" fit="contain" />
                </div>
                <i v-else class="el-icon-plus uploader-icon"></i>
              </el-upload>
              <div class="uploader-file-name">
                <span>{{ images.thumbnail.name }}</span>
              </div>
            </div>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="15">
        <el-col :span="10">
          <el-form-item label="Additional Images">
            <div class="uploader-image" v-for="(item, index) in images.additional_images"  :key="index">
              <div class="additional-pic">
                <div class="pic-group">
                  <el-upload
                    :show-file-list="false" action="" :http-request="uploadAdditionalImage" :before-upload="beforeImageUpload"
                    :data="{ model: 'products', id: product._id, type: 'additional_images', index: index }"
                  >
                    <div class="uploader-preview" v-if="item.url">
                      <el-image class="preview-img" :src="item.url" fit="contain" />
                    </div>
                    <i v-else class="el-icon-plus uploader-icon"></i>
                  </el-upload>
                  <div class="uploader-file-name">
                    <span>{{ item.name }}</span>
                  </div>
                </div>
                <div class="text-order">
                  <el-select
                    v-model="item.order" style="width: 60px;" placeholder=" " size="mini"
                    @change="((val) => {changeOrderAdditional(val, item.url)})"
                  >
                    <el-option v-for="num in images.additional_images.length"  :key="num" :label="num" :value="num"></el-option>
                  </el-select>
                </div>
              </div>
            </div>
            <div class="additional-image">
              <el-upload
                :show-file-list="false" action="" :http-request="uploadAdditionalImage" :before-upload="beforeImageUpload"
                :data="{ model: 'products', id: product._id, type: 'additional_images' }"
              >
                <i class="el-icon-plus uploader-icon"></i>
              </el-upload>
              <div class="uploader-file-name">
                <span>1080x1080 min.Square. 2MB max</span>
              </div>
            </div>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="15">
        <el-col :span="10">
          <el-form-item label="360° Group">
            <div class="group-360">
              <div class="uploader-image" v-for="(item, index) in images.group_360"  :key="index">
                <el-upload
                  :show-file-list="false" action="" :http-request="uploadImage" :before-upload="beforeImageUpload"
                  :data="{ model: 'products', id: product._id, type: 'group_360', index: index }"
                >
                  <div class="uploader-preview" v-if="images.group_360[index].url">
                    <el-image class="preview-img" :src="images.group_360[index].url" fit="contain" />
                  </div>
                  <i v-else class="el-icon-plus uploader-icon"></i>
                </el-upload>
                <div class="uploader-file-name">
                  <span>{{ images.group_360[index].name }}</span>
                </div>
              </div>
            </div>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row style="margin-top: 30px;">
        <el-form-item>
          <el-button class="el-btn-blue" @click="updateProduct" :loading="flagLoading.save">SAVE CHANGES</el-button>
          <el-button @click="returnBack">CANCEL</el-button>
        </el-form-item>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import { reactive } from 'vue'
import _ from 'lodash'
export default {
  name: 'TabImages',
  props: {
    tab: String,
    tabUpdate: Boolean,
    role: String,
    actionItem: Object
  },
  emits: ['changeSaveTab'],
  components: {
  },
  data () {
    const flagLoading = reactive({
      save: false
    })
    const flagVisible = reactive({
    })
    const actionItems = reactive({
    })
    const images = reactive({
      thumbnail: {},
      large: {},
      additional_images: [
      ],
      group_360: [
        { name: '', url: '' },
        { name: '', url: '' },
        { name: '', url: '' },
        { name: '', url: '' },
        { name: '', url: '' },
        { name: '', url: '' },
        { name: '', url: '' },
        { name: '', url: '' }
      ]
    })
    return {
      product: {},
      images,
      flagLoading,
      flagVisible,
      actionItems
    }
  },
  created: function () {
  },
  mounted () {
  },
  computed: {
  },
  watch: {
    actionItem: {
      handler: function (val, oldVal) {
        if (val !== oldVal) {
          if (val) this.product = { ...val }
          if (val && val.images) this.images = { ...val.images }
          if (val && !val.images.additional_images) this.images.additional_images = []
        }
      },
      deep: true
    },
    tabUpdate: {
      handler: function (val, oldVal) {
        if (val !== oldVal && val && this.tab === 'Images') {
          this.updateProduct()
          this.$emit('changeSaveTab', '')
        }
      },
      deep: true
    }
  },
  methods: {
    updateProduct: function () {
      this.$emit('changeSaveTab', '')
      this.flagLoading.save = true
      const url = `/api/v1/atk_player${this.role === 'admin' ? '/admin' : ''}/products/${this.product._id}`
      const that = this
      const body = { type: 'images', content: this.images }
      this.$service.put(url, body).then(function (res) {
        if (res.code === 200) {
          that.$message({ type: 'success', message: 'Update success' })
        } else {
          that.$message({ type: 'error', message: res.msg })
        }
        that.flagLoading.save = false
      }).catch(function (err) {
        console.error('updateProduct', err)
        that.$message({ type: 'error', message: err.msg })
        that.flagLoading.save = false
      })
    },
    returnBack: function () {
      this.$router.go(-1)
    },
    uploadImage: async function (params) {
      const { file, data } = params
      switch (data.type) {
        case 'thumbnail':
          this.images.thumbnail = { url: '', name: 'uploading...' }
          break
        case 'group_360':
          this.images.group_360[data.index] = { url: '', name: 'uploading...' }
          break
        default:
      }
      const that = this
      const formData = new FormData()
      formData.append('file', file)
      for (const key in data) {
        formData.append(key, data[key])
      }
      this.$service.request({
        url: '/api/v1/atk_player/upload/images',
        method: 'POST',
        data: formData,
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }).then((res) => {
        if (res.code === 200) {
          that.triggerTabUpdate()
          switch (data.type) {
            case 'thumbnail':
              that.images.thumbnail = { url: res.record.photo.url, name: file.name }
              break
            case 'group_360':
              that.images.group_360[data.index] = { url: res.record.photo.url, name: file.name }
              break
            default:
          }
        } else {
          that.$message({ type: 'error', message: res.msg })
        }
        that.flagLoading.save = false
      }).catch(function (err) {
        console.error('uploadImage', err)
        that.$message({ type: 'error', message: err.msg })
      })
    },

    uploadAdditionalImage: async function (params) {
      const { file, data } = params
      if (data.index || data.index === 0) {
        this.images.additional_images[data.index] = { url: '', name: 'uploading...', order: data.index + 1 }
      } else {
        this.images.additional_images[this.images.additional_images.length] = { url: '', name: 'uploading...', order: this.images.additional_images.length + 1 }
      }
      const extention = file.name.split('.').pop()
      this.timestamp = new Date().getTime()
      const key = 'images/origin/products/additional/' + this.product._id + '_' + this.timestamp + '.' + extention
      const uploadParams = {
        key
      }
      const url = '/api/v1/admin/aws/presigned'
      const that = this
      this.$service.post(url, uploadParams).then(function (res) {
        if (res.code === 200) {
          const presignedUrl = res.data.presigned_url
          const objUrl = new URL(presignedUrl)
          const imageUrl = `${objUrl.origin}${objUrl.pathname}`
          const xhr = new XMLHttpRequest()
          xhr.open('PUT', presignedUrl, true)
          xhr.setRequestHeader('Content-Type', file.type)
          xhr.setRequestHeader('x-amz-acl', 'public-read')
          xhr.onload = () => {
            if (xhr.status === 200) {
              if (data.index || data.index === 0) {
                that.images.additional_images[data.index] = { url: imageUrl, name: file.name, order: data.index + 1 }
              } else {
                that.images.additional_images[that.images.additional_images.length - 1] = { url: imageUrl, name: file.name, order: that.images.additional_images.length }
              }
            }
          }
          xhr.onerror = () => {
            console.error('upload to s3 | error')
            that.$message({ type: 'error', message: 'Upload error' })
          }
          xhr.send(file)
        } else {
          console.error('uploadImage | presigned_url', res.msg)
          that.$message({ type: 'error', message: res.msg })
        }
      }).catch(function (err) {
        console.error('uploadImage | presigned_url', err)
        that.$message({ type: 'error', message: err.msg })
      })
    },
    getSelected: function (url) {
      const index = _.findIndex(this.images.additional_images, { url })
      return index + 1
    },
    changeOrderAdditional: function (val, url) {
      const oldOrder = _.findIndex(this.images.additional_images, { url })
      if (val < oldOrder + 1) {
        this.images.additional_images.map(item => {
          if ((item.order === val && item.url !== url) || (item.order > val && item.order < oldOrder + 1)) {
            item.order += 1
          }
        })
      } else if (val > oldOrder + 1) {
        this.images.additional_images.map(item => {
          if ((item.order === val && item.url !== url) || (item.order > oldOrder + 1 && item.order < val)) {
            item.order -= 1
          }
        })
      }
      this.changeListOrder()
    },
    changeListOrder: function () {
      this.images.additional_images = _.orderBy(this.images.additional_images, ['order'], ['asc'])
    },
    beforeImageUpload (file) {
      // const isJPG = file.type === 'image/jpeg';
      const isLt2M = file.size / 1024 / 1024 < 2
      // if (!isJPG) {
      //   this.$message.error('上传头像图片只能是 JPG 格式!');
      // }
      if (!isLt2M) {
        this.$message.error('The size of the uploaded picture cannot exceed 2MB!')
      }
      return isLt2M
    },
    triggerTabUpdate: function () {
      this.$emit('changeSaveTab', 'Images')
    }
  }
}
</script>
<style lang="scss">
.tab-content.tab-images {
  .el-form-item__label {
    background-color: #F2F2F2!important;
    padding: 0 10px;
    line-height: 40px;
    margin-bottom: 10px;
  }
}
.uploader-image {
  display: flex;
  align-items: flex-end;
  .el-upload {
    border: 1px dashed #D9D9D9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    &:hover {
      border-color: #409EFF;
    }
    .uploader-icon {
      font-size: 26px;
      color: #8C939D;
      width: 100px;
      height: 100px;
      line-height: 100px;
      text-align: center;
    }
    .uploader-preview {
      width: 100px;
      height: 100px;
      padding: 10px;
      .preview-img {
        width: 80px;
        height: 80px;
      }
    }
  }
  .uploader-file-name {
    color: #ABABAB;
    padding: 0 0 10px 10px;
  }
  .additional-pic {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    .pic-group {
      display: flex;
      align-items: flex-end;
    }
  }
}
.additional-image {
  display: flex;
  align-items: flex-end;
  .el-upload {
    border: 1px dashed #D9D9D9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    &:hover {
      border-color: #409EFF;
    }
    .uploader-icon {
      font-size: 26px;
      color: #8C939D;
      width: 100px;
      height: 100px;
      line-height: 100px;
      text-align: center;
    }
    .uploader-preview {
      width: 100px;
      height: 100px;
      padding: 10px;
      .preview-img {
        width: 80px;
        height: 80px;
      }
    }
  }
  .uploader-file-name {
    color: #ABABAB;
    padding: 0 0 10px 10px;
  }
}
</style>
